import { useState } from "react";
import { useNavigate } from "react-router";
import ButtomNav from "../components/BottomNav";
import { auth } from "../functions/firebase";

export default function UserInfo() {

    const [names, setNames] = useState(localStorage.getItem("name") || "")
    const [phone, setPhone] = useState(localStorage.getItem("phone") || "")
    const navigate = useNavigate()
    const fAuth = {
        currentUser: auth.currentUser || JSON.parse(localStorage.getItem("user"))
    }

    async function updateUserName(e) {

        try {

            if(e) e.preventDefault()

            if(!names || !phone) {
                return alert("Phone and Names Required...")
            }

            navigate("/auth-1/" + fAuth.currentUser?.uid)
            localStorage.setItem("name", names)
            localStorage.setItem("phone", phone)

        } catch(err) {
            window.alert(err.message)
            console.log(err)
        }

    }


    return (
        <div>
            <div id="authForm">
                {/* <h1>Register</h1> */}
                <p style={{ textAlign: "center" }}>Enter your details below</p>
                
                <input 
                    placeholder="Your Names"
                    type="text"
                    value={names}
                    onChange={e => setNames(e.target.value)}
                />
                <input 
                    placeholder="+27685499070"
                    type="tel"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                />
                <p style={{ marginBottom: 20, color: "grey" }}>Your names will be used to identify your order</p>
                <button type="submit" onClick={updateUserName} style={{ backgroundColor: "var(--primary)"}} id="sign-in-button">Continue</button>
            </div>
            <ButtomNav user />
        </div>
    )
}